<div class="h-full min-h-0 flex flex-row gap-4 w-full">
    <!-- Left: model picker -->
    <aside
        class="w-1/3 min-w-0 min-h-0 flex flex-col rounded-xl border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-950">
        <div class="shrink-0 p-3 border-b border-zinc-200 dark:border-zinc-800">
            <div class="grid grid-cols-1">
                <input id="pricing-models-search" type="search" autocomplete="off"
                    aria-label="Search pricing models by title" placeholder="Search models…"
                    class="col-start-1 row-start-1 block w-full rounded-lg py-2 pr-3 pl-10 text-sm text-primary input-primary-icon"
                    [value]="searchQuery()" (input)="onSearchInput($any($event.target).value)" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-secondary sm:size-4">
                    <path d="m21 21-4.34-4.34" />
                    <circle cx="11" cy="11" r="8" />
                </svg>
            </div>
            <p class="mt-2 text-xs text-secondary">
                @if (modelsSource() !== undefined) {
                {{ modelsForCurrentTab()?.length ?? 0 }}
                @if (deletedListTab() === 'deleted') {
                deleted pricing model{{ (modelsForCurrentTab()?.length ?? 0) === 1 ? '' : 's' }}
                } @else {
                active pricing model{{ (modelsForCurrentTab()?.length ?? 0) === 1 ? '' : 's' }}
                }
                } @else {
                Loading…
                }
                @if (searchQuery().trim()) {
                <span class="text-primary"> · {{ displayPricingModels()?.length ?? 0 }} shown</span>
                }
            </p>
        </div>

        <div class="flex-1 min-h-0 overflow-y-auto p-2 scrollbar-transparent">
            @if (displayPricingModels() && displayPricingModels()!.length > 0) {
            <ul class="flex flex-col gap-1" role="listbox" aria-label="Pricing models">
                @for (model of displayPricingModels() ?? []; track model.id) {
                <li role="option" [attr.aria-selected]="isSelectedModel(model)">
                    <div class="group flex flex-row items-center justify-between gap-3 rounded-lg border px-3 py-2.5 transition-colors cursor-pointer"
                        [class]="
                      isSelectedModel(model)
                        ? 'border-primary/50 bg-primary/10 ring-1 ring-primary/35 dark:border-primary/45 dark:bg-primary/15 dark:ring-primary/25'
                        : 'border-transparent hover:border-zinc-200 hover:bg-zinc-50 dark:hover:border-zinc-700 dark:hover:bg-zinc-900/80'
                    " (click)="onModelSelect(model)">
                        <div class="flex min-w-0 flex-1 flex-col gap-0.5">
                            <span class="truncate text-sm font-medium text-primary leading-snug">{{
                                model.title || 'Unnamed model'
                                }}</span>
                            <span class="text-xs text-secondary">{{ model.createdDate | date:'dd/MM/yyyy' }}</span>
                        </div>

                        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
                            @if (model.charityDiscountPercentage && model.charityDiscountPercentage > 0) {
                            <span
                                class="h-8 inline-flex items-center gap-x-1.5 rounded-full bg-amber-100 px-2 py-1 text-xs font-medium text-amber-900 dark:bg-amber-950/50 dark:text-amber-200">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="size-4 shrink-0" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288" />
                                </svg>
                                {{ model.charityDiscountPercentage }}%
                            </span>
                            }
                            @if (model.isCurrent) {
                            <span class="flex items-center text-right text-green-600 dark:text-green-400"
                                title="Current pricing model">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="size-6 shrink-0" aria-hidden="true">
                                    <path fill-rule="evenodd"
                                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                                        clip-rule="evenodd" />
                                </svg>
                            </span>
                            }
                            @if (model.agencyId) {
                            <span class="flex items-center text-right text-cyan-600 dark:text-cyan-400"
                                title="Agency pricing model">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="size-6 shrink-0" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
                                </svg>
                            </span>
                            }
                            @if (model.businessAccountId) {
                            <span class="flex items-center text-right text-pink-600 dark:text-pink-400"
                                title="Brand pricing model">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="size-6 shrink-0" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
                                </svg>

                            </span>
                            }
                        </div>
                    </div>
                </li>
                }
            </ul>
            } @else if (modelsSource() !== undefined && (displayPricingModels()?.length ?? 0) === 0) {
            @if ((modelsForCurrentTab()?.length ?? 0) === 0) {
            <div class="px-2 py-8 text-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"
                    class="mx-auto size-12 text-secondary">
                    <path d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                @if (deletedListTab() === 'deleted') {
                <h3 class="mt-2 text-sm font-semibold text-primary">No deleted pricing models</h3>
                <p class="mt-1 text-sm text-secondary">There are no soft-deleted models to show.</p>
                } @else {
                <h3 class="mt-2 text-sm font-semibold text-primary">No active pricing models</h3>
                <p class="mt-1 text-sm text-secondary">Get started by creating a new pricing model.</p>
                <div class="mt-6">
                    <button type="button" routerLink="/create-pricing-model"
                        class="primary-button inline-flex items-center gap-x-2">
                        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5 shrink-0">
                            <path
                                d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                        </svg>
                        Add model
                    </button>
                </div>
                }
            </div>
            } @else {
            <div class="px-2 py-8 text-center">
                <p class="text-sm text-secondary">No models match your search.</p>
            </div>
            }
            } @else {
            <div class="h-full w-full flex flex-col items-center justify-center">
                <div class="text-center">
                    <svg aria-hidden="true" class="mx-auto size-12 animate-spin text-primary/30 fill-primary"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor" />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill" />
                    </svg>
                    <h3 class="mt-2 text-sm font-semibold text-primary">Loading…</h3>
                    <p class="mt-1 text-sm text-secondary">Should be done in a moment.</p>

                </div>

            </div>
            }
        </div>
        <div
            class="shrink-0 p-3 border-t border-zinc-200 dark:border-zinc-800 flex flex-row items-center justify-between">

            <div class="min-w-0 flex-1 sm:flex-none">
                <nav aria-label="Active or deleted pricing models" class="flex flex-wrap gap-2">
                    <button type="button" (click)="onListFilterTabChange('active')"
                        [attr.aria-pressed]="deletedListTab() === 'active'" [class]="getListFilterTabClass('active')">
                        Active
                    </button>
                    <button type="button" (click)="onListFilterTabChange('deleted')"
                        [attr.aria-pressed]="deletedListTab() === 'deleted'" [class]="getListFilterTabClass('deleted')">
                        Deleted
                    </button>
                </nav>
            </div>

            <button routerLink="/create-pricing-model" type="button"
                class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
                New Model
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="-mr-0.5 size-5">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </button>
        </div>
    </aside>
    <!-- Left: model picker - END -->

    <!-- Right: model details -->
    @if (selectedModel()) {
    <section
        class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-950">
        <!-- Model Header -->
        <div
            class="flex-0 flex shrink-0 flex-row flex-wrap items-center justify-between gap-2 border-b border-zinc-200 px-3 py-3 dark:border-zinc-800 drawer-header-primary">
            <div class="min-w-0 flex flex-col gap-0.5">
                <h3 class="text-base font-semibold text-primary truncate">{{ selectedModel()?.title }}</h3>
                <p class="text-sm text-secondary truncate">{{ selectedModel()?.id ?? 'Unknown' }}</p>
            </div>
            <div class="flex shrink-0 flex-row flex-wrap items-center justify-end gap-2">
                @if (selectedModel() && !selectedModel()!.isCurrent && !selectedModel()!.businessAccountId &&
                !selectedModel()!.agencyId) {
                <button type="button" (click)="setToCurrentModel()" class="primary-button shrink-0">
                    Set as current
                </button>
                }
                @if (selectedModel() && selectedModel()!.isCurrent) {
                <span class="text-sm font-medium text-primary whitespace-nowrap">Current pricing model</span>
                }
                @if (selectedModel() && selectedModel()!.businessAccountId) {
                <span class="text-sm font-semibold text-pink-600 dark:text-pink-400 whitespace-nowrap">Custom brand
                    model</span>
                }
                @if (selectedModel() && selectedModel()!.agencyId) {
                <span class="text-sm font-semibold text-cyan-600 dark:text-cyan-400 whitespace-nowrap">Custom agency
                    model</span>
                }
            </div>
        </div>
        <!-- Model Header - END -->

        <!-- Model Content -->
        <div class="drawer-body-primary flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-3 scrollbar-transparent">
            <ul role="list" class="grid grid-cols-1 gap-4 lg:grid-cols-3">
                <li
                    class="drawer-header-primary overflow-hidden rounded-lg shadow-sm outline -outline-offset-1 outline-zinc-300 dark:outline-white/10">
                    <div class="border-b border-zinc-200 px-4 py-3 dark:border-zinc-700">
                        <div class="text-sm font-semibold text-primary">License fees</div>
                    </div>
                    <dl class="-my-3 divide-y divide-zinc-200 px-4 py-3 text-sm leading-6 dark:divide-zinc-700">
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">UGC only</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.ugcPrice/100 |
                                currency:
                                selectedModel()!.currencyCode.toUpperCase()
                                }}</dd>
                        </div>
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">Ad content</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.advertisingPrice/100 |
                                currency:
                                selectedModel()!.currencyCode.toUpperCase()
                                }}</dd>
                        </div>
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">Social post</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.socialPostPrice/100 |
                                currency:
                                selectedModel()!.currencyCode.toUpperCase()
                                }}</dd>
                        </div>
                    </dl>
                </li>

                <li
                    class="drawer-header-primary overflow-hidden rounded-lg shadow-sm outline -outline-offset-1 outline-zinc-300 dark:outline-white/10">
                    <div class="border-b border-zinc-200 px-4 py-3 dark:border-zinc-700">
                        <div class="text-sm font-semibold text-primary">Video length</div>
                    </div>
                    <dl class="-my-3 divide-y divide-zinc-200 px-4 py-3 text-sm leading-6 dark:divide-zinc-700">
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">15 seconds</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.fifteenSecPrice/100 |
                                currency:
                                selectedModel()!.currencyCode.toUpperCase()
                                }}</dd>
                        </div>
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">30 seconds</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.thirtySecPrice/100 |
                                currency:
                                selectedModel()!.currencyCode.toUpperCase()
                                }}</dd>
                        </div>
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">60 seconds</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.sixtySecPrice/100 |
                                currency:
                                selectedModel()!.currencyCode.toUpperCase()
                                }}</dd>
                        </div>
                    </dl>
                </li>

                <li
                    class="drawer-header-primary overflow-hidden rounded-lg shadow-sm outline -outline-offset-1 outline-zinc-300 dark:outline-white/10">
                    <div class="border-b border-zinc-200 px-4 py-3 dark:border-zinc-700">
                        <div class="text-sm font-semibold text-primary">Face and commission</div>
                    </div>
                    <dl class="-my-3 divide-y divide-zinc-200 px-4 py-3 text-sm leading-6 dark:divide-zinc-700">
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">Face price</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.facePrice/100 |
                                currency:
                                selectedModel()!.currencyCode.toUpperCase()
                                }}</dd>
                        </div>
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">Base comms.</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.commissionPercentage
                                }}%</dd>
                        </div>
                        <div class="flex justify-between gap-x-4 py-3">
                            <dt class="text-secondary">License comms.</dt>
                            <dd class="tabular-nums text-primary font-medium">{{
                                selectedModel()!.licenseCommissionPercentage
                                }}%</dd>
                        </div>
                    </dl>
                </li>
            </ul>


            <!-- Influencer Levels -->
            <div class="min-w-0 px-4">
                <div class="flow-root">
                    <div class="-mx-3 overflow-x-auto sm:-mx-3">
                        <div class="inline-block min-w-full py-1 align-middle">
                            <div
                                class="overflow-hidden rounded-lg bg-card shadow-sm outline -outline-offset-1 outline-zinc-300 dark:outline-white/10">
                                <table class="min-w-full divide-y divide-zinc-300 dark:divide-zinc-700">
                                    <thead class="bg-zinc-50 dark:bg-zinc-900/50">
                                        <tr>
                                            <th scope="col"
                                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-primary sm:pl-6">
                                                Name</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-primary">
                                                Min.</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-primary">
                                                Max.</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-primary">
                                                Bonus</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-primary">
                                                Comm.</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-zinc-200 bg-card dark:divide-zinc-700">
                                        @for (level of
                                        selectedModel()!.influencerLevels;
                                        track $index) {
                                        <tr>
                                            <td
                                                class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-primary sm:pl-6">
                                                {{
                                                level.title }}</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-secondary">{{
                                                formatService.convertIntToString(level.followersFrom)
                                                }}</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-secondary">{{
                                                formatService.convertIntToString(level.followersTo)
                                                }}</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-secondary tabular-nums">
                                                {{
                                                selectedModel()!.currencyCode
                                                == 'usd' ? '$' : '£' }}{{
                                                level.bonusValue/100 }}</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-secondary tabular-nums">
                                                {{
                                                level.commission }}%</td>

                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Influencer Levels END -->


            <!-- Ranks -->
            <div class="min-w-0 px-4">
                <div class="flow-root">
                    <div class="-mx-3 overflow-x-auto sm:-mx-3">
                        <div class="inline-block min-w-full py-1 align-middle">
                            <div
                                class="overflow-hidden rounded-lg bg-card shadow-sm outline -outline-offset-1 outline-zinc-300 dark:outline-white/10">
                                <table class="min-w-full divide-y divide-zinc-300 dark:divide-zinc-700">
                                    <thead class="bg-zinc-50 dark:bg-zinc-900/50">
                                        <tr>
                                            <th scope="col"
                                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-primary sm:pl-6">
                                                Rank</th>
                                            <th scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-primary">
                                                Multiplier</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-zinc-200 bg-card dark:divide-zinc-700">
                                        @for (rank of
                                        selectedModel()!.ranks;
                                        track $index) {
                                        <tr>
                                            <td
                                                class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-primary sm:pl-6 tabular-nums">
                                                {{
                                                rank.rank }}</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-secondary tabular-nums">
                                                {{
                                                rank.multiplier }}x</td>

                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Ranks END -->

            <!-- Charity Details -->
            @if ((selectedModel()!.charityDiscountPercentage ?? 0) > 0) {
            <div
                class="drawer-header-primary mt-6 overflow-hidden rounded-lg border-l-4 border-amber-400 shadow-sm outline -outline-offset-1 outline-zinc-300 dark:border-amber-500 dark:outline-white/10">
                <div class="px-4 py-4">
                    <h2 class="text-base font-semibold text-primary">Charity pricing model</h2>
                    <p class="mt-1 text-sm text-secondary">
                        Discounted by:
                        <span class="font-semibold tabular-nums text-amber-900 dark:text-amber-200">{{
                            selectedModel()!.charityDiscountPercentage }}%</span>
                    </p>
                </div>
            </div>
            }
            <!-- Charity Details END -->
        </div>
        <!-- Model Content - END -->

        <!-- Model Footer -->
        @if (selectedModel() && !selectedModel()!.isDeleted) {
        <div
            class="flex-0 flex shrink-0 flex-row flex-wrap items-center justify-end gap-2 border-t border-zinc-200 px-3 py-3 dark:border-zinc-800 drawer-header-primary">
            <button (click)="deleteModel()" type="button"
                class="inline-flex items-center justify-center primary-button-danger disabled:opacity-50 disabled:cursor-not-allowed">
                Delete Model
            </button>
        </div>
        }
        <!-- Model Footer - END -->
    </section>
    } @else {
    <section
        class="flex min-h-0 min-w-0 flex-1 items-center justify-center rounded-xl border border-dashed border-zinc-300 bg-muted/30 p-6 dark:border-zinc-700">
        <p class="text-sm text-secondary text-center max-w-sm">Select a pricing model to view its details.
        </p>
    </section>
    }
    <!-- Right: model detail - END -->
</div>